import { type Event } from '@kalos/kalos-rpc';

import { UnifiedJobSelector } from '../UnifiedJobSelector';
import {
  type JobCheckStatus,
  JobSelectorLegacy,
  type JobSelectorLegacyProps,
} from './JobSelectorLegacy';

export type { JobCheckStatus };
export { JobSelectorLegacy };

export type JobSelectorProps = JobSelectorLegacyProps & {
  /**
   * When true (default), uses the project-aware selector (ValidateJobNumber + subjob accordion).
   * When false, uses the legacy job selector (hint combobox + AdvancedSearch).
   */
  projectSelection?: boolean;
  /** When projectSelection is true, auto-match to subjob of this department. Form value = subjob id. */
  departmentId?: number;
  /** Called with the full Event object when a job is confirmed (unified selector only). */
  onJobSelect?: (event: Event) => void;
};

/**
 * Job selector: search by job id. Uses the unified project/subjob-aware selector by default.
 * Use projectSelection=false for the legacy selector.
 */
export const JobSelector = ({
  projectSelection = true,
  departmentId,
  onJobSelect,
  ...rest
}: JobSelectorProps) => {
  if (projectSelection) {
    return <UnifiedJobSelector {...rest} departmentId={departmentId} onJobSelect={onJobSelect} />;
  }
  return <JobSelectorLegacy {...rest} />;
};
